module.exports = __webpack_public_path__ + "img/2_62.19018d20.png";